import { render } from "./SystemlogsList.vue?vue&type=template&id=5c145f50&scoped=true"
import script from "./SystemlogsList.vue?vue&type=script&lang=js"
export * from "./SystemlogsList.vue?vue&type=script&lang=js"

import "./SystemlogsList.vue?vue&type=style&index=0&id=5c145f50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c145f50"]])

export default __exports__